(function () {
  "use strict";

  const SELECTORS = {
    section: "[data-product-recommendations]",
    slider: "[data-recommendations-slider]",
    prevButton: "[data-recommendations-prev]",
    nextButton: "[data-recommendations-next]",
  };

  /**
   * Update navigation button states based on carousel position
   * @param {Object} embla - Embla carousel instance
   * @param {HTMLElement} prevButton - Previous button element
   * @param {HTMLElement} nextButton - Next button element
   */
  const updateButtonStates = (embla, prevButton, nextButton) => {
    if (!embla || !prevButton || !nextButton) return;

    prevButton.disabled = !embla.canScrollPrev();
    nextButton.disabled = !embla.canScrollNext();
  };

  /**
   * Initialize Embla carousel for the recommendations slider
   * @param {HTMLElement} section - The section container
   */
  const initializeSlider = (section) => {
    const sliderNode = section.querySelector(SELECTORS.slider);
    const prevButton = section.querySelector(SELECTORS.prevButton);
    const nextButton = section.querySelector(SELECTORS.nextButton);

    if (!sliderNode || !window.EmblaCarousel) return;

    const embla = window.EmblaCarousel(sliderNode, {
      loop: false,
      align: "start",
      skipSnaps: false,
      dragFree: true,
      containScroll: "trimSnaps",
    });

    const onUpdate = () => updateButtonStates(embla, prevButton, nextButton);
    embla.on("select", onUpdate);
    embla.on("reInit", onUpdate);
    onUpdate();

    if (prevButton) {
      prevButton.addEventListener("click", () => embla.scrollPrev());
    }
    if (nextButton) {
      nextButton.addEventListener("click", () => embla.scrollNext());
    }

    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        embla.reInit();
        onUpdate();
      }, 100);
    });
  };

  /**
   * Fetch product recommendations and replace section content
   * @param {HTMLElement} section - The section container with data-url attribute
   */
  const loadRecommendations = (section) => {
    const { url } = section.dataset;
    if (!url) return;

    fetch(url)
      .then((response) => {
        if (!response.ok) return;
        return response.text();
      })
      .then((text) => {
        if (!text) return;

        const html = document.createElement("div");
        html.innerHTML = text;

        const recommendations = html.querySelector(SELECTORS.section);
        if (recommendations && recommendations.innerHTML.trim().length) {
          section.replaceChildren(...recommendations.childNodes);
          initializeSlider(section);
        }
      })
      .catch(() => {});
  };

  /**
   * Initialize all product recommendation sections using IntersectionObserver
   */
  const init = () => {
    const sections = document.querySelectorAll(SELECTORS.section);

    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          obs.unobserve(entry.target);
          loadRecommendations(entry.target);
        });
      },
      { rootMargin: "200px" },
    );

    sections.forEach((section) => observer.observe(section));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
